<template>
	<div>
		<div v-on:click="closealertInvalid" role="alert" id="alertInvalid">
			<i class="fa fa-times" aria-hidden="true" style="float: right; display: none"></i>
			<p class="remove-margin">{{ message }}</p>
		</div>
		<div role="alert" id="alertSuccess" v-on:click="closealertSuccess">
			<i class="fa fa-times" aria-hidden="true" style="float: right; display: none"></i>
			<p class="remove-margin">{{ message }}</p>
		</div>
		<div v-on:click="closealertWarning" role="alert" id="alertWarning">
			<i class="fa fa-times" aria-hidden="true" style="float: right;color:#F3943F;display: none"></i>
			<p class="remove-margin" style="color: #F3943F;">{{ message }}</p>
		</div>
	</div>
</template>

<script>
export default {
	name: "Popup",
	props: ["popupType", "popupMessage", "popupErrorException"],
	data() {
		return {
			message: "",
		}
	},
	methods: {
		closealertInvalid() {
			$('#alertInvalid').removeClass("alert alert-danger animated fadeInDown to-top");
			$('#alertInvalid').addClass("alert alert-danger animated fadeOutUp");
			$('.fa.fa-times').hide()
			
			this.hideAlert('#alertInvalid');
			this.cleanup()
		},
		closealertSuccess() {
			$('#alertSuccess').removeClass("alert alert-success animated fadeInDown to-top");
			$('#alertSuccess').addClass("alert alert-success animated fadeOutUp");
			$('.fa.fa-times').hide()
			
			this.hideAlert('#alertSuccess')
			this.cleanup()
		},
		closealertWarning() {
			$('#alertWarning').removeClass("alert alert-custome animated fadeInDown to-top");
			$('#alertWarning').addClass("alert alert-custome animated fadeOutUp");
			$('.fa.fa-times').hide()
			
			this.hide('#alertWarning')
			this.cleanup()
		},
		showAlert(id) {
			$(id).show();
			$('.fa.fa-times').show()
		},
		hideAlert(id) {
			setTimeout(() => {
				$(id).hide();
			}, 1000)
		},
		cleanup() {
			this.$emit("cleanup")
		}
	},
	watch: {
		popupMessage: function (msg) {
			if (msg === "") {
				return
			}
			$('.fa.fa-times').show()
			if (this.popupType === "error") {
				this.showAlert('#alertInvalid')
				$('#alertInvalid').removeClass("alert alert-danger animated fadeOutUp to-top");
				$('#alertInvalid').addClass("alert alert-danger animated fadeInDown to-top");
				
				setTimeout(() => {
					$('#alertInvalid').removeClass("alert-danger animated fadeInDown to-top");
					$('#alertInvalid').addClass("alert-danger animated fadeOutUp to-top");
					this.hideAlert('#alertInvalid')
				}, 30000);
				
				$('#alertSuccess').hide();
				$('#alertWarning').hide();
			} else if (this.popupType === "success") {
				this.showAlert('#alertSuccess')
				$('#alertSuccess').removeClass("alert alert-success animated fadeOutUp to-top");
				$('#alertSuccess').addClass("alert alert-success animated fadeInDown to-top");
				
				setTimeout(() => {
					$('#alertSuccess').removeClass("alert alert-success animated fadeInDown to-top");
					$('#alertSuccess').addClass("alert alert-success animated fadeOutUp to-top");
					this.hideAlert('#alertSuccess')
				}, 30000);
				
				$('#alertInvalid').hide();
				$('#alertWarning').hide();
			} else if (this.popupType === "warning") {
				this.showAlert('#alertWarning')
				$('#alertWarning').removeClass("alert alert-custome animated fadeOutUp to-top");
				$('#alertWarning').addClass("alert alert-custome animated fadeInDown to-top");
				
				setTimeout(() => {
					$('#alertWarning').removeClass("alert alert-custome animated fadeInDown to-top");
					$('#alertWarning').addClass("alert alert-custome animated fadeOutUp to-top");
					this.hideAlert('#alertWarning')
				}, 30000);
				
				$('#alertSuccess').hide();
				$('#alertInvalid').hide();
			}

			this.message = msg
		},
		popupErrorException: function (e) {
			if (e === null) {
				return
			}
			if (this.popupType === "error") {
				$('.fa.fa-times').show()
				$('#alertInvalid').removeClass("alert alert-danger animated fadeOutUp to-top");
				$('#alertInvalid').addClass("alert alert-danger animated fadeInDown to-top");
				
				if (!e.code) {
					this.message = "Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti";
					if (e.response.status === 500) {
						this.message = e.response.data.msg;
					}
				} else {
					this.message = e.response.data.msg;
					if (e.code === "ECONNABORTED") {
						this.message = "Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti";
						setTimeout(function () {
							$('#alertInvalid').removeClass("alert-danger animated fadeInDown to-top");
							$('#alertInvalid').addClass("alert-danger animated fadeOutUp to-top");
							$('#alertInvalid').hide();
						}, 30000);
					}
				}
			}
		}
	}
}
</script>

<style scoped>
	.to-top {
		z-index: 9999 !important;
	}
	
	.alert-custome {
		background: #FCF4D9;
		box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.07);
		border-radius: 3px;
		border: 1px solid #F6BC88;
	}
</style>